import * as e from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/Pencil.es.js";
const o = e.forwardRef((c, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...c, weights: n }));
o.displayName = "PencilIcon";
const m = o;
export {
  m as Pencil,
  o as PencilIcon
};
